<template>
  <div v-if="tendency != undefined">
    <div class="flex items-center justify-center rounded-full" :class="[colorClasses, sizeClasses]">
      <BaseIcon :size="iconSize">{{ icon }}</BaseIcon>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import BaseIcon from '../icon/BaseIcon.vue'

  interface Props {
    tendency: number
    size?: 'small' | 'medium'
  }

  const { tendency, size = 'small' } = defineProps<Props>()

  const sizeClasses = computed(() => {
    if (size === 'small') {
      return 'h-5 px-1 py-0.5'
    }
    return 'h-7 px-1.5 py-1'
  })

  const colorClasses = computed(() => {
    if (tendency < 0) {
      return 'bg-bibelirot-90 text-bibelirot-20'
    }
    if (tendency > 0) {
      return 'bg-marsmenschli-90 text-marsmenschli-20'
    }
    return 'bg-surface-container-highest'
  })

  const icon = computed(() => {
    if (tendency < 0) {
      return 'trending_down'
    }
    if (tendency > 0) {
      return 'trending_up'
    }
    return 'trending_flat'
  })

  const iconSize = computed(() => {
    if (size === 'small') {
      return '18'
    }
    return '24'
  })
</script>
